<script>
    import { onMount } from 'svelte';
    import { io } from "socket.io-client";
    import LiveDataItem from './LiveDataItem.svelte'

    let socket;

    //const WS_SERVER = 'http://localhost:5590'
    //const WS_SERVER = 'https://moonshot-nw.wotapool.net:5591'
    //const POOL_ID = 'pool130tcc6ls8nf0xslu222dcdph2ayp2tmkk429fdevx7mkg5zeun0';

    const WS_SERVER = 'https://moonshot-nd.wotapool.net:5591'
    const POOL_ID = 'pool1krznhwu3h5pu2stuslr53z5rme50t6384macsmylcnljwc7yjky';

    // TODO move to utils
    function thousandSep(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    }

    let saturation = {value:'', unit:'%', sub:'', color:'gray', arrow:'none'};
    let stake = {value:'', unit:'₳', sub:'', color:'gray', arrow:'none'};
    let delegators = {value:'', unit:'', sub:'', color:'gray', arrow:'none'};
    let pledge = {value:'', unit:'₳', sub:'', color:'gray', arrow:'none'};
    let blocks = {value:'', unit:'', sub:'', color:'gray', arrow:'none'};
    let rewards = {value:'', unit:'₳', sub:'', color:'gray', arrow:'none'};
    let ros = {value:'', unit:'%', sub:'', color:'gray', arrow:'none'};
    

    //let liveData = { delegators: null, stake: null, saturation: null, pledge: null };
    let liveData = { delegators: null, stake: null, saturation: null };
    let epochData = { delegators: null, stake: null, pledge: null };
    let rosData = { percentile: null, rank: null, tot: null};
    let rosShow = 1;

    function onLiveDataReceived(message)
    {
        // let msg = JSON.stringify(message)
        // console.log("received live data message: "+ msg);

        liveData.delegators = message.live_delegators_count;
        liveData.stake = message.live_stake;
        liveData.saturation = message.live_saturation;
        //liveData.pledge = message.owners_live_stake;
        
        saturation.value = Math.round(liveData.stake/liveData.saturation*100*100)/100;
        stake.value = thousandSep(liveData.stake);
        delegators.value = liveData.delegators;
        //pledge.value = thousandSep(liveData.pledge);

        if(epochData.stake) {
            updateLiveDataDiff();
        }
    }

    function onEpochDataReceived(message) 
    {
        // let msg = JSON.stringify(message)
        // console.log("received epoch data message: "+ msg);

        epochData.delegators = message.delegators_count;
        epochData.stake = message.active_stake;
        epochData.saturation = message.saturation;
        epochData.pledge = message.owners_stake;

        if(liveData.stake) {
            updateLiveDataDiff();
        }
    }


    function updateLiveDataDiff()
    {
        const live_sat = liveData.stake/liveData.saturation*100;
        const epoch_sat = epochData.stake/epochData.saturation*100;

        const delta_saturation =  Math.round((live_sat - epoch_sat)*100)/100;
        const delta_stake = Math.round((liveData.stake-epochData.stake) / epochData.stake * 100 *100)/100;
        const delta_delegators = Math.round((liveData.delegators-epochData.delegators) / epochData.delegators * 100 *100)/100;
        const delta_pledge = Math.round((liveData.pledge-epochData.pledge) / epochData.pledge * 100 *100)/100;
        
        saturation.sub = delta_saturation + "%";

        if (delta_saturation > 0) {
            saturation.color = 'green';
            saturation.arrow = 'up';
        } else if (delta_saturation < 0) {
            saturation.color = 'red';
            saturation.arrow = 'down';
        } else {
            saturation.sub = '';
            saturation.color = 'gray';
            saturation.arrow = 'even';
        }

        const stake_diff = liveData.stake-epochData.stake;
        //stake.sub = delta_stake + '%';
        //stake.sub = thousandSep(Math.abs(stake_diff)) + '<span style="font-size: 0.8em"> ₳</span>&nbsp; (' + delta_stake + '%)';
        stake.sub = thousandSep(Math.abs(stake_diff)) + '<span style="font-size: 0.8em"> ₳</span>';

        if (stake_diff > 0) {
            stake.color = 'green';
            stake.arrow = 'up';
        } else if (stake_diff < 0) {
            stake.color = 'red';
            stake.arrow = 'down';
        } else {
            stake.sub = '';
            stake.color = 'gray';
            stake.arrow = 'even';
        }

        //delegators.sub = delta_delegators + '%';
        //delegators.sub = Math.abs(liveData.delegators-epochData.delegators) + '&nbsp; (' + delta_delegators + '%)';
        delegators.sub = Math.abs(liveData.delegators-epochData.delegators);

        if (delta_delegators > 0) {
            delegators.color = 'green';
            delegators.arrow = 'up';
        } else if (delta_delegators < 0) {
            delegators.color = 'red';
            delegators.arrow = 'down';
        } else {
            delegators.sub = '';
            delegators.color = 'gray';
            delegators.arrow = 'even';
        }

        pledge.sub = delta_pledge + '%';

        if (delta_pledge > 0) {
            pledge.color = 'green';
            pledge.arrow = 'up';
        } else if (delta_pledge < 0) {
            pledge.color = 'red';
            pledge.arrow = 'down';
        } else {
            pledge.sub = '';
            pledge.color = 'gray';
            pledge.arrow = 'even';
        }
    }

    function onBlocksDataReceived(message) 
    {
        //let msg = JSON.stringify(message)
        //console.log("received block data message: "+ msg);

        blocks.value = message.lifetime_blocks;
        blocks.sub = "current epoch: " + message.blocks_current_epoch;
        rewards.sub = "over " + message.epochs_with_blocks + "  epochs";
    }

    function onRosDataReceived(message) 
    {
        // let msg = JSON.stringify(message)
        // console.log("received ROS data message: "+ msg);

        // const lros = Math.round(message.lifetime_ros_compounded * 100 * 100) / 100;
        const lros = Math.round(message.ros * 100 * 100) / 100;
        const rank = message.pool_rank;
        const tot = message.active_pools;

        rosData.rank = rank;
        rosData.tot = tot;

        let rank_perc = Math.ceil((rank/tot)*100);

        if (rank_perc > 25)
            rank_perc = Math.ceil(rank_perc / 10) * 10;
        else if (rank_perc > 3)
            rank_perc = Math.ceil(rank_perc / 5) * 5;

        rosData.percentile = rank_perc;

        ros.value = lros;
        ros.sub = "Top " + rank_perc + "% pools";
        if (rank_perc <= 10) ros.color = "green";
        else ros.color = "gray";

        setInterval(cycleROS, 8000);
    }

    function onLifetimeDataReceived(message) 
    {
        //let msg = JSON.stringify(message)
        //console.log("received: "+ msg);
        rewards.value = thousandSep(message.total_rewards);
    }

    async function updateDelegationData()
    {
        // TODO: make global variables
        const urlAPI = "https://moonshot-nd.wotapool.net:5581/api/v1";
        const poolHash = 'pool1krznhwu3h5pu2stuslr53z5rme50t6384macsmylcnljwc7yjky';

        const apiUrl = urlAPI+"/pools/"+poolHash+"/live/delegation-b";

        const res = await fetch(apiUrl);
		let poolData = await res.json();

        liveData.delegators = poolData[0].live_delegators;
        liveData.stake = Math.round(poolData[0].live_stake/1000000);
        liveData.saturation = poolData[0].live_stake/poolData[0].live_saturation/1000000;
        
        saturation.value = Math.round(poolData[0].live_saturation*10000)/100;
        stake.value = thousandSep(liveData.stake);
        delegators.value = liveData.delegators;

        if(epochData.stake) {
            updateLiveDataDiff();
        }
    }


    function cycleROS()
    {
        rosShow = 1 - rosShow;

        if (rosShow == 1) {
            ros.sub = "Top " + rosData.percentile + "% pools";
        }
        else {
            ros.sub = "Rank: " + rosData.rank + " / " + rosData.tot;
        }
    }

    onMount(async () => {
        //socket = io(`${WS_SERVER_URL}:${WS_SERVER_PORT}`);
        socket = io(WS_SERVER);
        //socket.on("live_data", onLiveDataReceived);
        socket.on("epoch_data", onEpochDataReceived);
        socket.on("blocks_data", onBlocksDataReceived);
        socket.on("lifetime_data", onLifetimeDataReceived);
        socket.on("ros_data_1y", onRosDataReceived);
		socket.emit("subscribe", POOL_ID);

        socket.on("connect_error", () => {
            //alert("SOCKET.IO: CONNECTION ERROR");
        });

        updateDelegationData();
	});

</script>


<div class="container">
    <LiveDataItem title='LIVE SATURATION' value={saturation.value} unit={saturation.unit} sub={saturation.sub} color={saturation.color} arrow={saturation.arrow} />
    <LiveDataItem title='LIVE STAKE' value={stake.value} unit={stake.unit} sub={stake.sub} color={stake.color} arrow={stake.arrow} />
    <LiveDataItem title='LIVE DELEGATORS' value={delegators.value} unit={delegators.unit} sub={delegators.sub} color={delegators.color} arrow={delegators.arrow} />
    <!-- <LiveDataItem title='LIVE PLEDGE' /> -->
    <LiveDataItem title='LIFETIME BLOCKS' value={blocks.value} unit={blocks.unit} sub={blocks.sub} color={blocks.color} arrow={blocks.arrow} />
    <LiveDataItem title='LIFETIME REWARDS' value={rewards.value} unit={rewards.unit} sub={rewards.sub} color={rewards.color} arrow={rewards.arrow} />
    <LiveDataItem title='LAST YEAR ROS' value={ros.value} unit={ros.unit} sub={ros.sub} color={ros.color} arrow={ros.arrow} />
</div>


<style>

.container {
    display: flex;
    justify-content: space-between;
    gap: 0.75em;
    padding-bottom: 3em;
}

@media screen and (max-width: 1000px)
{
	.container {
        flex-wrap: wrap;
        justify-content: center;
    }
}

</style>